import { InjectionToken, Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import Debug from 'debug';
import { __awaiter } from 'tslib';
import { createAction, props, createSelector, createReducer, on, select, Store, StoreModule } from '@ngrx/store';
import { take, filter, mergeMap, retry, map, catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { createEffect, ofType, Actions, EffectsModule } from '@ngrx/effects';
import { CommonModule } from '@angular/common';
import { of } from 'rxjs';
import { InjectedTextFeautureModule, NamedString, InjectedTextProvider } from '@modeso/modeso-lib-core-fe';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/payment.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function PaymentConfig() { }
if (false) {
    /** @type {?} */
    PaymentConfig.prototype.serviceId;
}
/** @type {?} */
const PaymentConfigService = new InjectionToken('Config');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/payment.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug = Debug('modeso:lidl-lib-payment-fe:PaymentService');
/** @type {?} */
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};
/**
 * @record
 */
function PaymentOptionsResponse() { }
if (false) {
    /** @type {?} */
    PaymentOptionsResponse.prototype.paymentOptions;
}
class PaymentService {
    // private readonly singleProductRoute = ':id';
    /**
     * @param {?} http
     * @param {?} config
     */
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.server = '';
        this.microserviceName = 'payment';
        this.paymentsRoute = '/';
        this.server = config.apiGateway;
        debug('PaymentServiceId: ' + config.serviceId);
    }
    /**
     * @return {?}
     */
    getAllPaymentOptions() {
        debug('get all Payment options called');
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.paymentsRoute}`;
        return this.http.get(url);
    }
    /**
     * @param {?} payload
     * @return {?}
     */
    getPaymentStatus(payload) {
        debug('get payment status function called');
        /** @type {?} */
        const orderId = payload.orderId;
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.paymentsRoute}${orderId}/status`;
        return this.http.get(url);
    }
    /**
     * @param {?} payment
     * @return {?}
     */
    initializePayment(payment) {
        debug('Initialize payment');
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.paymentsRoute}`;
        return this.http.post(url, payment.payload);
    }
    /**
     * @param {?} orderId
     * @return {?}
     */
    getPaymentProcessStatus(orderId) {
        debug('get payment process status');
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.paymentsRoute}${orderId}`;
        return this.http.get(url);
    }
}
PaymentService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
PaymentService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [PaymentConfigService,] }] }
];
/** @nocollapse */ PaymentService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PaymentService_Factory() { return new PaymentService(ɵɵinject(HttpClient), ɵɵinject(PaymentConfigService)); }, token: PaymentService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    PaymentService.prototype.server;
    /**
     * @type {?}
     * @private
     */
    PaymentService.prototype.microserviceName;
    /**
     * @type {?}
     * @private
     */
    PaymentService.prototype.paymentsRoute;
    /**
     * @type {?}
     * @private
     */
    PaymentService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    PaymentService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/payment-option.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Payment Option Model that return
 */
class PaymentOpionModel {
    /**
     * @param {?} paymentId the option id.
     * @param {?} paymentName the option name.
     */
    constructor(paymentId, paymentName) {
        this.paymentId = paymentId;
        this.paymentName = paymentName;
    }
}
if (false) {
    /** @type {?} */
    PaymentOpionModel.prototype.paymentId;
    /** @type {?} */
    PaymentOpionModel.prototype.paymentName;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/actions/payment.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const getAllPaymentOptions = createAction('[Payment options List] getAllPaymentOptions');
/** @type {?} */
const getPaymentStatus = createAction('[Payment status] getPaymentStatus', props());
/**
 * @record
 */
function IActionWithOrderId() { }
if (false) {
    /** @type {?} */
    IActionWithOrderId.prototype.orderId;
}
/** @type {?} */
const intializePayment = createAction('[Payment options List] intializePayment', props());
/**
 * create an Action of get all payment options
 * check https://ngrx.io/guide/store/actions
 * @type {?}
 */
const onAllPaymentOptionsLoadedSuccessfully = createAction('[Payment options List] all payment options loaded successfully', props());
/** @type {?} */
const onAllPaymentOptionsLoadingFailed = createAction('[Payment options List] all Payment options loading failed', props());
/** @type {?} */
const onPaymentOptionsValidSelected = createAction('[Payment options List] payment options selected successfully', props());
/** @type {?} */
const onTermsAndConditionsAccepted = createAction('[Payment options List] all terms and conditions are accepted');
/** @type {?} */
const onTermsAndConditionsRejected = createAction('[Payment options List] terms and conditions are accepted');
/** @type {?} */
const onGetPaymentStatusSuccess = createAction('[Payment status] payment status request created successfully', props());
/** @type {?} */
const onGetPaymentStatusReject = createAction('[Payment status] payment status request could not be  created successfully', props());
/** @type {?} */
const onIntializePaymentSuccessfully = createAction('[Payment options List] intializePayment succefully', props());
/** @type {?} */
const onIntializePaymentFailed = createAction('[Payment options List] intializePayment failed', props());
/** @type {?} */
const getPaymentProcessStatus = createAction('[Payment] getPaymentProcessStatus', props());
/** @type {?} */
const onGetPaymentProcessStatusSuccessful = createAction('[Payment] getPaymentProcessStatus successful', props());
/** @type {?} */
const onGetPaymentProcessStatusFailed = createAction('[Payment] getPaymentProcessStatus failed', props());
/**
 * @record
 * @template T
 */
function ActionWithPayload() { }
if (false) {
    /** @type {?} */
    ActionWithPayload.prototype.payload;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/payment-process-status-response.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PaymentProcessStatusResponse {
}
if (false) {
    /** @type {?} */
    PaymentProcessStatusResponse.prototype.paymentProcessStatus;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reducers/payment.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const paymentOptionsFeatureKey = 'modesoPaymentMicroservice';
/**
 * @record
 */
function FeatureState() { }
if (false) {
    /** @type {?} */
    FeatureState.prototype.paymentOptions;
    /** @type {?} */
    FeatureState.prototype.paymentOptionSelected;
    /** @type {?} */
    FeatureState.prototype.termsAndConditions;
    /** @type {?} */
    FeatureState.prototype.paymentStatus;
    /** @type {?} */
    FeatureState.prototype.redirectUrl;
    /** @type {?} */
    FeatureState.prototype.paymentProcessStatus;
}
/**
 * @record
 */
function AppState() { }
if (false) {
    /** @type {?} */
    AppState.prototype.modesoPaymentMicroservice;
}
// State Declarations - END
// Selectors Declarations - START
/** @type {?} */
const selectFeature = (/**
 * @param {?} state
 * @return {?}
 */
(state) => state.modesoPaymentMicroservice);
const ɵ0 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.paymentOptions;
/** @type {?} */
const selectFeaturePaymentOptions = createSelector(selectFeature, (ɵ0));
const ɵ1 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.paymentOptionSelected;
/** @type {?} */
const selectPaymentOptionModel = createSelector(selectFeature, (ɵ1));
const ɵ2 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.termsAndConditions;
/** @type {?} */
const TermsAndConditionsState = createSelector(selectFeature, (ɵ2));
const ɵ3 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (state.termsAndConditions &&
    state.paymentOptionSelected &&
    state.paymentOptionSelected.paymentId) ? true : false;
/** @type {?} */
const isPaymentValid = createSelector(selectFeature, (ɵ3));
const ɵ4 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.paymentStatus;
/** @type {?} */
const paymentStatus = createSelector(selectFeature, (ɵ4));
const ɵ5 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.redirectUrl;
/** @type {?} */
const paymentRedirectUrlFeature = createSelector(selectFeature, (ɵ5));
const ɵ6 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.paymentProcessStatus;
/** @type {?} */
const paymentProcessStatusFeature = createSelector(selectFeature, (ɵ6));
// Reducer Declarations - START
/** @type {?} */
const initialState = {
    paymentOptions: new Array(),
    paymentOptionSelected: undefined,
    termsAndConditions: false,
    paymentStatus: {
        validPayment: false,
        message: '',
        paymentProcessStatus: ''
    },
    redirectUrl: null,
    paymentProcessStatus: new PaymentProcessStatusResponse()
};
const ɵ7 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ8 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { paymentOptions: action.payload })), ɵ9 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ10 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { paymentOptionSelected: action.payload })), ɵ11 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { termsAndConditions: true })), ɵ12 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { termsAndConditions: false })), ɵ13 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ14 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { paymentStatus: action.payload })), ɵ15 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { paymentStatus: action.payload })), ɵ16 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state)), ɵ17 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { redirectUrl: action.payload.redirectUrl, paymentStatus: {
        validPayment: false, message: '',
        paymentProcessStatus: 'INITIALIZED'
    } })), ɵ18 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { redirectUrl: null })), ɵ19 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ20 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { paymentProcessStatus: action.payload })), ɵ21 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state));
/** @type {?} */
const paymentReducer = createReducer(initialState, on(getAllPaymentOptions, (ɵ7)), on(onAllPaymentOptionsLoadedSuccessfully, (ɵ8)), on(onAllPaymentOptionsLoadingFailed, (ɵ9)), on(onPaymentOptionsValidSelected, (ɵ10)), on(onTermsAndConditionsAccepted, (ɵ11)), on(onTermsAndConditionsRejected, (ɵ12)), on(getPaymentStatus, (ɵ13)), on(onGetPaymentStatusSuccess, (ɵ14)), on(onGetPaymentStatusReject, (ɵ15)), on(intializePayment, (ɵ16)), on(onIntializePaymentSuccessfully, (ɵ17)), on(onIntializePaymentFailed, (ɵ18)), on(getPaymentProcessStatus, (ɵ19)), on(onGetPaymentProcessStatusSuccessful, (ɵ20)), on(onGetPaymentProcessStatusFailed, (ɵ21)));
/**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
function reducer(state, action) {
    return paymentReducer(state, action);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/paymentProcessStatus.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const PaymentProcessStatus = {
    INITIALIZED: "INITIALIZED",
    STARTED: "STARTED",
    SUCCESSED: "SUCCESSED",
    FAILED: "FAILED",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/checkout-payment-options/checkout-payment-options.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$1 = Debug('modeso:lidl-lib-payment-fe:CheckoutPaymentOptionsComponent');
class CheckoutPaymentOptionsComponent {
    /**
     * @param {?} store
     * @param {?} router
     */
    constructor(store, router) {
        this.store = store;
        this.router = router;
        this.paymentStatus = new EventEmitter();
        this.paymentOptions$ = this.store.pipe(select(selectFeaturePaymentOptions));
        this.selectedOption = new PaymentOpionModel('', '');
        this.paymentProcessStatus = new PaymentProcessStatusResponse();
        this.loading = false;
        this.hasError = false;
        this.errorMessage = '';
    }
    /**
     * @param {?} showLoading
     * @return {?}
     */
    set showLoadingSpinner(showLoading) {
        if (showLoading) {
            this.loading = true;
        }
    }
    /**
     * @param {?} paymentOptionId
     * @param {?} paymentOptionName
     * @return {?}
     */
    onPaymentOptionChanged(paymentOptionId, paymentOptionName) {
        this.store.dispatch(onPaymentOptionsValidSelected({ payload: new PaymentOpionModel(paymentOptionId, paymentOptionName) }));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.store.dispatch(getAllPaymentOptions());
        this.getSelectedOption();
        if (this.isPaymentDone && this.paymentOrderId) {
            this.loading = true;
            this.orderId = this.paymentOrderId;
            this.getPaymentProcessStatus().subscribe((/**
             * @param {?} status
             * @return {?}
             */
            (status) => {
                this.paymentProcessStatus = status;
                // if status is initialized only send request
                if (this.paymentProcessStatus.paymentProcessStatus === PaymentProcessStatus.INITIALIZED) {
                    this.store.dispatch(getPaymentStatus({ orderId: this.orderId }));
                }
            }));
            this.getPaymentStatus();
        }
    }
    /**
     * @return {?}
     */
    getPaymentStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            this.store.pipe(select(paymentStatus)).subscribe((/**
             * @param {?} paymentStatus
             * @return {?}
             */
            paymentStatus => {
                if (paymentStatus) {
                    this.loading = false;
                    this.paymentStatus.emit(paymentStatus);
                }
                debug$1(paymentStatus);
            }));
        });
    }
    /**
     * check the selected payment option in the store
     * @return {?}
     */
    getSelectedOption() {
        return __awaiter(this, void 0, void 0, function* () {
            this.selectedOption = yield this.store.pipe(select(selectPaymentOptionModel), take(1)).toPromise();
            debug$1(this.selectedOption);
        });
    }
    /**
     * @return {?}
     */
    getPaymentProcessStatus() {
        this.store.dispatch(getPaymentProcessStatus({ orderId: this.paymentOrderId }));
        return this.store.pipe(select(paymentProcessStatusFeature), filter((/**
         * @param {?} status
         * @return {?}
         */
        (status) => status.paymentProcessStatus !== undefined || 'paymentProcessStatus' in status)));
    }
}
CheckoutPaymentOptionsComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-checkout-payment-options',
                template: "<div *ngIf=\"loading\" class=\"overlay d-flex justify-content-center\">\r\n  <div class=\"spinner-border text-primary align-self-center\">\r\n  </div>\r\n</div>\r\n<div class=\"payment-options\">\r\n  <h5 class=\"options-title\">\r\n    {{ \"modeso_payment_checkout-payment-options_payment-options-caption\" | injectedText | async }}</h5>\r\n  <ul>\r\n    <ng-container *ngFor=\"let paymentOption of paymentOptions$ | async ; let i = index;\">\r\n      <li>\r\n        <input type=\"radio\" name=\"payment-option\" id=\"option-{{i}}\"\r\n          [checked]=\"selectedOption && paymentOption.paymentId === selectedOption.paymentId\"\r\n          (change)=\"onPaymentOptionChanged(paymentOption.paymentId,paymentOption.paymentName)\" />\r\n        <label for=\"option-{{i}}\" class=\"icon\">\r\n          <img src=\"assets/lidl-lib-payment-fe/{{ paymentOption.paymentId | lowercase }}.svg\">\r\n        </label>\r\n        <label for=\"option-{{i}}\">{{paymentOption.paymentName}}</label>\r\n      </li>\r\n    </ng-container>\r\n  </ul>\r\n</div>\r\n",
                styles: [".payment-options{margin-top:2em}.payment-options .options-title{font-size:16px;border-bottom:1px solid #ececec;margin-bottom:20px;padding-bottom:8px;font-weight:700}.payment-options ul{padding-left:0;list-style:none}.payment-options ul li{padding:10px 0;border-bottom:1px solid #ececec}.payment-options ul li label{font-size:16px;margin-bottom:0}.payment-options ul li input{margin-right:10px;margin-top:0;vertical-align:middle}.payment-options ul li .icon{width:44px;height:28px;margin:0 10px;vertical-align:middle}.payment-options ul li .icon img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.overlay{position:fixed;display:none;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:2;cursor:pointer}"]
            }] }
];
/** @nocollapse */
CheckoutPaymentOptionsComponent.ctorParameters = () => [
    { type: Store },
    { type: Router }
];
CheckoutPaymentOptionsComponent.propDecorators = {
    isPaymentDone: [{ type: Input }],
    paymentOrderId: [{ type: Input }],
    paymentStatus: [{ type: Output }],
    showLoadingSpinner: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CheckoutPaymentOptionsComponent.prototype.isPaymentDone;
    /** @type {?} */
    CheckoutPaymentOptionsComponent.prototype.paymentOrderId;
    /** @type {?} */
    CheckoutPaymentOptionsComponent.prototype.paymentStatus;
    /** @type {?} */
    CheckoutPaymentOptionsComponent.prototype.paymentOptions$;
    /** @type {?} */
    CheckoutPaymentOptionsComponent.prototype.selectedOption;
    /** @type {?} */
    CheckoutPaymentOptionsComponent.prototype.paymentProcessStatus;
    /** @type {?} */
    CheckoutPaymentOptionsComponent.prototype.loading;
    /** @type {?} */
    CheckoutPaymentOptionsComponent.prototype.hasError;
    /** @type {?} */
    CheckoutPaymentOptionsComponent.prototype.errorMessage;
    /** @type {?} */
    CheckoutPaymentOptionsComponent.prototype.orderId;
    /**
     * @type {?}
     * @private
     */
    CheckoutPaymentOptionsComponent.prototype.store;
    /**
     * @type {?}
     * @private
     */
    CheckoutPaymentOptionsComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/checkout-terms/checkout-terms.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CheckoutTermsComponent {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
        this.acceptTerm1 = false;
        this.acceptTerm2 = false;
        this.acceptTerm3 = false;
        this.termsAccepted = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.acceptTerm1 = yield this.store.pipe(select(TermsAndConditionsState), take(1)).toPromise();
            this.acceptTerm2 = this.acceptTerm1;
            this.acceptTerm3 = this.acceptTerm1;
        });
    }
    /**
     * @return {?}
     */
    emitAcceptedTerms() {
        if (this.acceptTerm1 && this.acceptTerm2 && this.acceptTerm3) {
            this.store.dispatch(onTermsAndConditionsAccepted());
        }
        else {
            this.store.dispatch(onTermsAndConditionsRejected());
        }
    }
}
CheckoutTermsComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-checkout-terms',
                template: "<div class=\"terms-of-service\">\r\n  <ul>\r\n    <li>\r\n      <input type=\"checkbox\" id=\"acceptTerms1\" name=\"acceptTerms1\" [checked]=\"acceptTerm1\"\r\n        (change)=\"acceptTerm1 = !acceptTerm1; emitAcceptedTerms()\">\r\n      <label for=\"acceptTerms1\" [innerHTML]=\"'modeso_payment_checkout-terms_accept-terms-text1' | injectedText | async\">\r\n      </label>\r\n    </li>\r\n    <li>\r\n      <input type=\"checkbox\" id=\"acceptTerms2\" name=\"acceptTerms2\" [checked]=\"acceptTerm2\"\r\n        (change)=\"acceptTerm2 = !acceptTerm2; emitAcceptedTerms()\">\r\n      <label for=\"acceptTerms2\" [innerHTML]=\"'modeso_payment_checkout-terms_accept-terms-text2' | injectedText | async\">\r\n      </label>\r\n    </li>\r\n    <li>\r\n      <input type=\"checkbox\" id=\"acceptTerms3\" name=\"acceptTerms3\" [checked]=\"acceptTerm3\"\r\n        (change)=\"acceptTerm3 = !acceptTerm3; emitAcceptedTerms()\">\r\n      <label for=\"acceptTerms3\" [innerHTML]=\"'modeso_payment_checkout-terms_accept-terms-text3' | injectedText | async\">\r\n      </label>\r\n    </li>\r\n  </ul>\r\n</div>\r\n",
                styles: [".terms-of-service ul{padding:0;list-style:none}.terms-of-service ul li{font-weight:400;display:flex;margin-left:1em;margin-bottom:.5em}.terms-of-service ul li label{padding-left:1em;margin:0}"]
            }] }
];
/** @nocollapse */
CheckoutTermsComponent.ctorParameters = () => [
    { type: Store }
];
CheckoutTermsComponent.propDecorators = {
    termsAccepted: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    CheckoutTermsComponent.prototype.acceptTerm1;
    /** @type {?} */
    CheckoutTermsComponent.prototype.acceptTerm2;
    /** @type {?} */
    CheckoutTermsComponent.prototype.acceptTerm3;
    /** @type {?} */
    CheckoutTermsComponent.prototype.termsAccepted;
    /**
     * @type {?}
     * @private
     */
    CheckoutTermsComponent.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/paymentStatus.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PaymentStatusModel {
}
if (false) {
    /** @type {?} */
    PaymentStatusModel.prototype.validPayment;
    /** @type {?} */
    PaymentStatusModel.prototype.message;
    /** @type {?} */
    PaymentStatusModel.prototype.paymentProcessStatus;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/effects/payment.effects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$2 = Debug('modeso:lidl-lib-payment-fe:PaymentEffects');
class PaymentEffects {
    /**
     * @param {?} actions$
     * @param {?} service
     */
    constructor(actions$, service) {
        this.actions$ = actions$;
        this.service = service;
        this.loadAllPaymentOptions$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(getAllPaymentOptions.type), mergeMap((/**
         * @return {?}
         */
        () => {
            return this.service.getAllPaymentOptions()
                .pipe(retry(1), map((/**
             * @param {?} paymentResponse
             * @return {?}
             */
            paymentResponse => (onAllPaymentOptionsLoadedSuccessfully({ payload: paymentResponse.paymentOptions })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onAllPaymentOptionsLoadingFailed({ payload: error })))));
        })))));
        this.getCurrentPaymentStatus$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(getPaymentStatus.type), mergeMap((/**
         * @param {?} payload
         * @return {?}
         */
        payload => {
            return this.service.getPaymentStatus(payload)
                .pipe(map((/**
             * @param {?} paymentStatusResponse
             * @return {?}
             */
            paymentStatusResponse => (onGetPaymentStatusSuccess({ payload: paymentStatusResponse })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                /** @type {?} */
                const errorWithStatus = new PaymentStatusModel();
                errorWithStatus.message = error.error.message;
                errorWithStatus.validPayment = error.error.validPayment;
                errorWithStatus.paymentProcessStatus = error.paymentProcessStatus;
                return of(onGetPaymentStatusReject({ payload: errorWithStatus }));
            })));
        })))));
        this.initializePayment$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(intializePayment.type), mergeMap((/**
         * @param {?} payload
         * @return {?}
         */
        payload => {
            return this.service.initializePayment({ payload })
                .pipe(map((/**
             * @param {?} paymentResponse
             * @return {?}
             */
            paymentResponse => (onIntializePaymentSuccessfully({ payload: paymentResponse })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onIntializePaymentFailed({ payload: error })))));
        })))));
        this.getPaymentProcessStatus$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(getPaymentProcessStatus.type), mergeMap((/**
         * @param {?} payload
         * @return {?}
         */
        (payload) => {
            return this.service.getPaymentProcessStatus(payload.orderId)
                .pipe(map((/**
             * @param {?} paymentProcessStatusResponse
             * @return {?}
             */
            paymentProcessStatusResponse => (onGetPaymentProcessStatusSuccessful({ payload: paymentProcessStatusResponse })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onGetPaymentProcessStatusFailed({ payload: error })))));
        })))));
        this.errorOnGetPaymentProcessStatus$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onGetPaymentProcessStatusFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllOptionsErrors(action.payload))))), { dispatch: false });
        this.errorOnInitalizePayment$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onIntializePaymentFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllOptionsErrors(action.payload))))), { dispatch: false });
        this.errorOnLoadAllProducts$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onAllPaymentOptionsLoadingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllOptionsErrors(action.payload))))), { dispatch: false });
        this.errorOnGetPaymentStatus$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onGetPaymentStatusReject.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllOptionsErrors(action.payload))))), { dispatch: false });
    }
    /**
     * @param {?} error
     * @return {?}
     */
    handleOnLoadAllOptionsErrors(error) {
        debug$2(error);
        return error;
    }
}
PaymentEffects.decorators = [
    { type: Injectable }
];
/** @nocollapse */
PaymentEffects.ctorParameters = () => [
    { type: Actions },
    { type: PaymentService }
];
if (false) {
    /** @type {?} */
    PaymentEffects.prototype.loadAllPaymentOptions$;
    /** @type {?} */
    PaymentEffects.prototype.getCurrentPaymentStatus$;
    /** @type {?} */
    PaymentEffects.prototype.initializePayment$;
    /** @type {?} */
    PaymentEffects.prototype.getPaymentProcessStatus$;
    /** @type {?} */
    PaymentEffects.prototype.errorOnGetPaymentProcessStatus$;
    /** @type {?} */
    PaymentEffects.prototype.errorOnInitalizePayment$;
    /** @type {?} */
    PaymentEffects.prototype.errorOnLoadAllProducts$;
    /** @type {?} */
    PaymentEffects.prototype.errorOnGetPaymentStatus$;
    /**
     * @type {?}
     * @private
     */
    PaymentEffects.prototype.actions$;
    /**
     * @type {?}
     * @private
     */
    PaymentEffects.prototype.service;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/checkout-payment-selected/checkout-payment-selected.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CheckoutPaymentSelectedComponent {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
        this.selectedPaymentOption$ = this.store.select(selectPaymentOptionModel);
    }
}
CheckoutPaymentSelectedComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-checkout-payment-selected',
                template: "<div class=\"order-details-container\">\r\n  <h5 class=\"title\">{{ \"modeso_payment_checkout-payment-options_payment-options-caption\" | injectedText | async }} </h5>\r\n  <span *ngIf=\"selectedPaymentOption$ | async\">\r\n    <label class=\"icon\">\r\n      <img src=\"assets/lidl-lib-payment-fe/{{ (selectedPaymentOption$ | async).paymentId | lowercase }}.svg\">\r\n    </label>\r\n    <label id=\"paymentSelected\">{{(selectedPaymentOption$ | async).paymentName}}</label>\r\n  </span>\r\n</div>\r\n",
                styles: [".order-details-container .title{font-size:16px;font-weight:700;line-height:20px;border-bottom:1px solid #d4d1d4;margin-bottom:21px;margin-top:0;padding-bottom:10px}.order-details-container label{font-size:16px;margin-bottom:0}.order-details-container .icon{width:44px;height:28px;margin:0 10px 0 0;vertical-align:middle}.order-details-container .icon img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}"]
            }] }
];
/** @nocollapse */
CheckoutPaymentSelectedComponent.ctorParameters = () => [
    { type: Store }
];
if (false) {
    /** @type {?} */
    CheckoutPaymentSelectedComponent.prototype.selectedPaymentOption$;
    /**
     * @type {?}
     * @private
     */
    CheckoutPaymentSelectedComponent.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-selected-view/payment-selected-view.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PaymentSelectedViewComponent {
    constructor() { }
}
PaymentSelectedViewComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-payment-fe-payment-selected-view',
                template: "<div class=\"order-details-container\">\r\n  <h5 class=\"title\">{{ \"modeso_payment_checkout-payment-options_payment-options-caption\" | injectedText | async }} </h5>\r\n  <span>\r\n    <label class=\"icon\">\r\n      <img src=\"assets/lidl-lib-payment-fe/{{ paymentOption?.paymentId | lowercase }}.svg\">\r\n    </label>\r\n    <label id=\"paymentSelected\">{{ paymentOption?.paymentName }}</label>\r\n  </span>\r\n</div>\r\n",
                styles: [".order-details-container .title{font-size:16px;font-weight:700;line-height:20px;border-bottom:1px solid #d4d1d4;margin-bottom:21px;margin-top:0;padding-bottom:10px}.order-details-container label{font-size:16px;margin-bottom:0}.order-details-container .icon{width:44px;height:28px;margin:0 10px 0 0;vertical-align:middle}.order-details-container .icon img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}"]
            }] }
];
/** @nocollapse */
PaymentSelectedViewComponent.ctorParameters = () => [];
PaymentSelectedViewComponent.propDecorators = {
    paymentOption: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    PaymentSelectedViewComponent.prototype.paymentOption;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/payment.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PaymentModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: PaymentModule,
            providers: [
                PaymentService,
                {
                    provide: PaymentConfigService,
                    useValue: config
                },
            ]
        };
    }
}
PaymentModule.decorators = [
    { type: NgModule, args: [{
                declarations: [CheckoutTermsComponent,
                    CheckoutPaymentOptionsComponent, CheckoutPaymentSelectedComponent, PaymentSelectedViewComponent],
                providers: [PaymentService],
                imports: [
                    CommonModule,
                    InjectedTextFeautureModule,
                    StoreModule.forFeature(paymentOptionsFeatureKey, reducer),
                    EffectsModule.forFeature([PaymentEffects]),
                ],
                exports: [CheckoutTermsComponent,
                    CheckoutPaymentOptionsComponent,
                    CheckoutPaymentSelectedComponent,
                    PaymentSelectedViewComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/provider/paymentStore.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$3 = Debug('modeso:lidl-lib-payment-fe:PaymentStoreProvider');
/** @type {?} */
const strings = [
    { 'modeso_payment_checkout-terms_accept-terms-text': 'Ich akzeptiere die <span>Allgemeinen Geschäftsbedingungen</span> der LIDL Schweiz AG.' },
    { 'modeso_payment_checkout-terms_accept-privacy-text': 'Die Hinweise zum Datenschutz habe ich zur Kenntnis genommen.' },
    { 'modeso_payment_checkout-payment-options_payment-options-caption': 'Zahlungsart' }
];
class PaymentStoreProvider {
    /**
     * @param {?} store
     * @param {?} injectedTextProvider
     */
    constructor(store, injectedTextProvider) {
        this.store = store;
        this.injectedTextProvider = injectedTextProvider;
        /** @type {?} */
        const defaultStrings = new Array();
        strings.forEach((/**
         * @param {?} element
         * @return {?}
         */
        (element) => {
            /** @type {?} */
            const x = new NamedString(Object.keys(element)[0], element[Object.keys(element)[0]]);
            defaultStrings.push(x);
        }));
        debug$3('set default text - Payment');
        this.setInjectedText(defaultStrings);
    }
    /**
     * @return {?}
     */
    getSelectedPaymentOption$() {
        return this.store.pipe(select(selectPaymentOptionModel));
    }
    /**
     * check payment page validation
     * @return {?}
     */
    isPaymentValid() {
        return this.store.pipe(select(isPaymentValid), map((/**
         * @param {?} isValid
         * @return {?}
         */
        (isValid) => {
            return isValid;
        })));
    }
    /**
     * re-inisialize store validation when order is done
     * @return {?}
     */
    refreshStore() {
        this.store.dispatch(onPaymentOptionsValidSelected({ payload: null }));
        this.store.dispatch(onTermsAndConditionsRejected());
    }
    /**
     * @private
     * @param {?} injectedText
     * @return {?}
     */
    setInjectedText(injectedText) {
        this.injectedTextProvider.setInjectedText(injectedText);
    }
    /**
     * @param {?} payment
     * @return {?}
     */
    initializePayment$(payment) {
        this.store.dispatch(intializePayment(payment));
        return this.store.pipe(select(paymentRedirectUrlFeature));
    }
    // public getCurrentPaymentStatus$(orderId): Observable<any> {
    //   this.store.dispatch(paymentActions.getPaymentStatus(orderId))
    //   return this.store.pipe(select(fromFeature.paymentStatus));
    // }
    /**
     * @param {?} orderId
     * @return {?}
     */
    getPaymentProcessStatus$(orderId) {
        this.store.dispatch(getPaymentProcessStatus({ orderId }));
        return this.store.pipe(select(paymentProcessStatusFeature), filter((/**
         * @param {?} status
         * @return {?}
         */
        (status) => status.paymentProcessStatus !== undefined || 'paymentProcessStatus' in status)));
    }
}
PaymentStoreProvider.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
PaymentStoreProvider.ctorParameters = () => [
    { type: Store },
    { type: InjectedTextProvider }
];
/** @nocollapse */ PaymentStoreProvider.ngInjectableDef = ɵɵdefineInjectable({ factory: function PaymentStoreProvider_Factory() { return new PaymentStoreProvider(ɵɵinject(Store), ɵɵinject(InjectedTextProvider)); }, token: PaymentStoreProvider, providedIn: "root" });
if (false) {
    /** @type {?} */
    PaymentStoreProvider.prototype.store;
    /**
     * @type {?}
     * @private
     */
    PaymentStoreProvider.prototype.injectedTextProvider;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/IPaymentStatusResponse.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IPaymentStatusResponse() { }
if (false) {
    /** @type {?} */
    IPaymentStatusResponse.prototype.validPayment;
    /** @type {?} */
    IPaymentStatusResponse.prototype.message;
    /** @type {?} */
    IPaymentStatusResponse.prototype.paymentProcessStatus;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modeso-giftcardshop-lib-payment-fe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { CheckoutPaymentOptionsComponent, CheckoutTermsComponent, PaymentConfigService, PaymentModule, PaymentOpionModel, PaymentProcessStatus, PaymentProcessStatusResponse, PaymentService, PaymentStoreProvider, paymentOptionsFeatureKey as ɵa, initialState as ɵc, reducer as ɵd, CheckoutPaymentSelectedComponent as ɵe, PaymentSelectedViewComponent as ɵf, getAllPaymentOptions as ɵg, getPaymentStatus as ɵh, intializePayment as ɵi, onAllPaymentOptionsLoadedSuccessfully as ɵj, onAllPaymentOptionsLoadingFailed as ɵk, onPaymentOptionsValidSelected as ɵl, onTermsAndConditionsAccepted as ɵm, onTermsAndConditionsRejected as ɵn, onGetPaymentStatusSuccess as ɵo, onGetPaymentStatusReject as ɵp, onIntializePaymentSuccessfully as ɵq, onIntializePaymentFailed as ɵr, getPaymentProcessStatus as ɵs, onGetPaymentProcessStatusSuccessful as ɵt, onGetPaymentProcessStatusFailed as ɵu, PaymentEffects as ɵv };
